


import * as Actions from '../actions';

const initialState = {
    isLoading: true,
    errMsg: null,
    data: []
    };


// get active categories
export const bankReceiptInvoiceReducer1 = function(state = initialState, action) {
switch (action.type) {
case Actions.UPDATE_BANK_RECEIPT1:
return { ...state, isLoading: false, errMsg: null, data: action.payload };
case Actions.UPDATE_BANK_RECEIPT1_LOADING:
return { ...state, isLoading: true, errMsg: null, data: [] };
case Actions.UPDATE_BANK_RECEIPT1_LOADING_FAILED:
return { ...state, isLoading: false, errMsg: action.payload, data: [] };
default:
return state;
}
};
